import { Injectable } from "@angular/core";
import { Platform } from 'ionic-angular';
import { IOrder } from '../../model/models/order/order-interface';
import { LoggerProvider, LoggerEvent } from '../logger/logger';

declare let FirebaseCrashlytics;

@Injectable()
export class FirebaseAnalyticsProvider {

    crashlytics: any;

    constructor(private platform: Platform) {}

    initAnalytics() {
        this.crashlytics = FirebaseCrashlytics.initialise();
    }

    trackFirstOrder(order: IOrder): void {
        if (!this.platform.is('ios')) return;
        if (order.countEnteredOrders !== 1) return;
        try {
            this.crashlytics.logEvent('first_transaction', {
                value: order.sendAmountUSD || 0,
                currency: order.currencyFrom || '',
                transaction_id: order.orderNumber || ''
            });
        } catch (ex) {
            LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Firebase trackFirstOrder failed');
        }
    }

}



// WEBPACK FOOTER //
// ./src/providers/analytics/firebase-analytics.ts